// @generated by TypeGen from LogbookModel/EditPermissiveness.swift - DO NOT EDIT

export enum IDayEditableField {
  comment = "comment",
  crew = "crew",
  endLocation = "endLocation",
  passengers = "passengers",
  skipper = "skipper",
  startLocation = "startLocation",
}

export enum IEditPermissivenessLevel {
  strict = "strict",
  extended = "extended",
  unrestricted = "unrestricted",
}

export enum ILogEditableField {
  comment = "comment",
  course = "course",
  currentDirection = "currentDirection",
  currentSpeed = "currentSpeed",
  depth = "depth",
  distance = "distance",
  engineRpms = "engineRpms",
  heading = "heading",
  humidity = "humidity",
  location = "location",
  log = "log",
  pressure = "pressure",
  seaState = "seaState",
  sog = "sog",
  stw = "stw",
  temperature = "temperature",
  watch = "watch",
  watchComment = "watchComment",
  weather = "weather",
  windDirection = "windDirection",
  windSpeed = "windSpeed",
}

export enum ILogFieldEditability {
  always = "always",
  nmeaCapable = "nmeaCapable",
  locked = "locked",
}
